import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const Edit: React.FC<IconProps> = (props) => (
  <Icon viewBox="3 3 31.7 31.7" {...props}>
    <path
      d="M33,6.8l-1.6-1.6c-0.6-0.6-1.5-1-2.3-1.1c-1.2-0.1-2.4,0.3-3.2,1.1L6.2,25.1c-0.4,0.4-0.7,1-0.8,1.6l-0.7,4.1l-0.5,3.3
    l3.3-0.5l4.3-0.7c0.6-0.1,1.2-0.4,1.6-0.8L33,12.4l0,0l0,0C34.6,10.8,34.5,8.3,33,6.8z M11.7,30.4c-0.1,0.1-0.2,0.1-0.3,0.1
    l-4.3,0.7l0.7-4.1c0-0.1,0.1-0.2,0.1-0.3l16.2-16.3l3.7,3.7L11.7,30.4z M31.3,10.7C31.3,10.7,31.3,10.7,31.3,10.7l-1.8,1.8
    l-3.7-3.7L27.6,7c0.3-0.3,0.8-0.5,1.2-0.4c0.3,0,0.6,0.2,0.9,0.4l1.6,1.6C31.8,9.2,31.9,10.1,31.3,10.7z"
    />
  </Icon>
);
